var _key = '_id';
export var setResolveIdKey = function (key) { return (_key = key); };
export var resolveId = function (obj) { return obj === null || obj === void 0 ? void 0 : obj[_key]; };
